<template>
    <div class="chart-container">
        <!-- 为图表设置固定宽高容器，保证渲染效果 -->
        <canvas id="trendChart" width="900" height="300"></canvas>
    </div>
</template>

<script>
import Chart from 'chart.js'

export default {
    name: 'TrendLineChart',
    data() {
        return {
            chartInstance: null // 保存图表实例，方便后续销毁
        }
    },
    props:{ 
        arrs: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    watch: {
        // 监听父组件传入的arr变化，自动更新图表
        arrs: {
            deep: true, // 深度监听数组内容变化
            handler() {
                this.updateChart()
            }
        }
    },
    beforeDestroy() {
        // 销毁图表实例，防止内存泄漏
        if (this.chartInstance) {
            this.chartInstance.destroy()
        }
    },
    mounted() {
        this.initChart()
    },
    methods: {
        // 更新图表
        updateChart() {
            if (this.chartInstance) {
                this.chartInstance.destroy()
            }
            this.initChart()
        },
        processData() {
            if (!this.arrs || this.arrs.length === 0) {
                return { xLabels: [], yData: [] }
            }
            const xLabels = this.arrs.map(item => {
                let a = item.time.split(' ')[0].split('-')
                return a[1]+'/'+a[2]
            })
            const yData = this.arrs.map(item => {
                // 处理百分比：去掉%符号，转成数字（如'0.5%' → 0.5）
                return Number(item.rate.replace('%', ''))
            })
            return { xLabels, yData }
        },
        initChart() {
            const ctx = document.getElementById('trendChart').getContext('2d')
            const { xLabels, yData } = this.processData()
            console.log(xLabels, yData,'xLabels, yData')
            // 1. 创建渐变背景（美化核心）
            const gradient = ctx.createLinearGradient(0, 0, 0, 400)
            gradient.addColorStop(0, 'rgba(75, 192, 192, 0.4)') // 顶部渐变颜色
            gradient.addColorStop(1, 'rgba(75, 192, 192, 0)') // 底部透明

            // 2. 图表配置项
            const chartConfig = {
                type: 'line',
                data: {
                    // X轴标签
                    labels: xLabels,
                    datasets: [
                        {
                            label: '',
                            // 模拟数据
                            data: yData,
                            // 基础样式
                            backgroundColor: gradient, // 渐变填充
                            borderColor: '#22C55E', // 线条颜色
                            borderWidth: 2, // 线条宽度
                            pointBackgroundColor: '#22C55E', // 点的填充色
                            pointBorderColor: 'rgba(75, 192, 192, 0)', // 点的边框色
                            pointBorderWidth: 2, // 点的边框宽度
                            pointRadius: 1, // 点的大小
                            pointHoverRadius: 5, // 悬停时点的大小
                            pointHoverBackgroundColor: '#22C55E', // 悬停时点的填充色
                            pointHoverBorderColor: '#fff', // 悬停时点的边框色
                            tension: 0.4, // 曲线平滑度（0-1，1最平滑）
                            fill: true, // 填充线下区域
                            lineTension: 0.4 // 兼容旧版本的平滑度设置
                        }
                    ]
                },
                options: {
                    // 响应式
                    responsive: true,
                    maintainAspectRatio: false,
                    // 动画
                    animation: {
                        duration: 1500, // 动画时长
                        easing: 'easeOutQuart' // 动画缓动效果
                    },
                    // 图例
                    legend: {
                        display: false,
                        position: 'top', // 图例位置
                        labels: {
                            fontColor: '#64A89D', // 字体颜色
                            fontSize: 12, // 字体大小
                            fontStyle: 'bold', // 字体样式
                            padding: 20 // 内边距
                        }
                    },
                    // 提示框
                    tooltips: {
                        enabled: true,
                        borderColor: '#083A2D', // 新增：提示框边框色（和折线色一致）
                        borderWidth: 1, // 新增：提示框边框宽度
                        backgroundColor: 'rgba(5,46,36, 0.9)', // 背景色
                        titleFontSize: 12, // 标题字体大小
                        titleFontColor: '#6FEAB8',
                        bodyFontSize: 12, // 内容字体大小
                        bodyFontColor: '#6FEAB8', // 内容文字颜色（和折线主色一致）
                        padding: 10, // 内边距
                        cornerRadius: 4, // 圆角
                        displayColors: true, // 隐藏颜色小方块
                        // 自定义提示框内容
                        callbacks: {
                            label: function (tooltipItem, data) {
                                return `${data.datasets[tooltipItem.datasetIndex].label}: ${tooltipItem.yLabel} profit`
                            }
                        }
                    },
                    // 网格线
                    scales: {
                        xAxes: [
                            {
                                // 核心：修改X轴底部轴线颜色 + 确保显示
                                borderColor: '#4bc0c0', // 替换成你想要的颜色（如红色 #ff0000）
                                // 关键：隐藏X轴网格线，但保留底部轴线
                                gridLines: {
                                    display: false, // 隐藏所有X轴网格线
                                    drawBorder: true // 强制显示底部的那一根轴线
                                },
                                ticks: {
                                    fontColor: '#fff', // 刻度文字颜色
                                    fontSize: 12 // 刻度文字大小
                                },
                            }
                        ],
                        yAxes: [
                            {
                                gridLines: {
                                    color: 'rgba(23,61,53, 1)', // Y轴网格线颜色（浅灰色）
                                    drawBorder: false // 隐藏Y轴边框
                                },
                                ticks: {
                                    fontColor: '#fff',
                                    fontSize: 12,
                                    // Y轴刻度格式化
                                    callback: function (value) {
                                        return value + '%'
                                    },
                                    // 从0开始
                                    beginAtZero: true
                                }
                            }
                        ]
                    },
                    // 悬停效果
                    hover: {
                        mode: 'index', // 悬停时高亮同索引的所有点
                        intersect: false // 不强制鼠标精准点在数据点上
                    },
                    // 边框
                    elements: {
                        line: {
                            tension: 0.4 // 线条平滑度
                        }
                    }
                }
            }

            // 创建图表实例
            this.chartInstance = new Chart(ctx, chartConfig)
        }
    }
}
</script>

<style scoped>
.chart-container {
    width: 100%;
    max-width: 1000px;
    margin: 20px auto;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
</style>